import { GENDER } from '../constants';
import { IStateContextData } from '../interfaces/state.interfaces';

export const getGenderType = (
  gender: IStateContextData['gender'],
): 1 | 2 | 3 => {
  if (gender === GENDER.MALE) return 1;
  if (gender === GENDER.FEMALE) return 2;
  return 3;
};

export const isMale = (gender: IStateContextData['gender']): boolean =>
  gender === GENDER.MALE;
